<app-base-layout
  [darkMode]="false"
  [showFooter]="false"
>
<div class="container">
    <div class="container-content">
      <div class="biometry-page-content">
        <div *ngIf="messageBiometria">
          <div [innerHTML]="messageBiometria | safeHtml"></div>
        </div>
        <div *ngIf="!messageBiometria">
          <h1 data-renderer-start-pos="14"class="form-next-title">Etapa de Biometria</h1>
          <div class="form-next-description">
            <p data-renderer-start-pos="35">
              Nesta etapa, precisamos que voc&ecirc; capture e envie imagens do seu
              documento e do seu rosto. &Eacute; necess&aacute;rio que o seu
              dispositivo tenha c&acirc;mera para seguirmos com a an&aacute;lise.
            </p>
            <p data-renderer-start-pos="204">
              Veja algumas orienta&ccedil;&otilde;es abaixo:
            </p>
            <ul data-indent-level="1">
              <li>
                <p data-renderer-start-pos="240">
                  Permita o acesso &agrave; c&acirc;mera do seu dispositivo quando
                  solicitado e procure um ambiente com boa ilumina&ccedil;&atilde;o
                  para capturar sua foto;
                </p>
              </li>
              <li>
                <p data-renderer-start-pos="371">
                  Retire qualquer acess&oacute;rio que dificulte a
                  visualiza&ccedil;&atilde;o do seu rosto, como por exemplo
                  &oacute;culos, fones de ouvido e m&aacute;scara, e mantenha os
                  l&aacute;bios fechados durante a foto;
                </p>
              </li>
              <li>
                <p data-renderer-start-pos="541">
                  Enquadre seu rosto dentro do c&iacute;rculo exibido;
                </p>
              </li>
              <li>
                <p data-renderer-start-pos="590">
                  Sempre que poss&iacute;vel, retire o documento do pl&aacute;stico e
                  o enquadre dentro do ret&acirc;ngulo. Os dados devem ficar
                  leg&iacute;veis na foto.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="biometry-page-content-button">
          <app-rounded-button (click)="nextStep()">
            Ok, prosseguir
          </app-rounded-button>
        </div>
      </div>
    </div>
    <div class="img-entrada"></div>
  </div>
</app-base-layout>
